<template>
  <div v-if="tb.tbShow" > 
    <div>
      <!-- //PC TOOLAR -->
      <v-app-bar v-if="!phoneSize"
        app="" dark=""
        :color="tb.tbColor"
        :flat="tb.tbFlat">
        <router-link to="/">
          <v-img   
            class="mx-4" 
            height="50"  
            max-width="50"
            :src="require(`@/assets/teresiansisters/logo.png`)"
          /> 
        </router-link>
        <router-link to="/" class="not-line0" >
          <v-toolbar-title class="white--text font-weight-bold" >{{not.appName}}</v-toolbar-title>
        </router-link>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text="" to="/">Home</v-btn> 
          <v-btn text="" to="/religious-formation">Religious Formation</v-btn>  
          <v-btn text="" to="/services">Services</v-btn> 
          <v-btn text="" to="/news">News</v-btn> 
          <v-btn text="" to="/events">Events</v-btn> 
          <v-btn text="" to="/gallery">Gallery</v-btn> 
          
          <v-menu   
            bottom="" 
            offset-y
            :nudge-width="250" open-on-hover="">
            <template v-slot:activator="{ on }"> 
              <v-btn v-on="on" text="" to="/about">About Us</v-btn>
            </template> 
            <v-card color="primary lighten-1" class=""> 
                <v-row class="mx-3"> 
                  <v-col >
                    <v-subheader dark="" class="white--text font-weight-bold">ABOUT US</v-subheader>
                    <v-divider></v-divider>
                    <v-divider></v-divider>
                    <v-list single-line dense="" subheader=""> 
                      <v-sheet   >
                        <v-list-item to="/about" @click="clicked">Information</v-list-item> 
                        <v-divider></v-divider>
                      </v-sheet>  
                      <v-sheet >
                        <v-list-item to="/about/sisters" @click="clicked">Sisters</v-list-item> 
                        <v-divider></v-divider>
                      </v-sheet>
                      <v-sheet >
                        <v-list-item to="/about/communities" @click="clicked">Dioceses & communities</v-list-item> 
                        <v-divider></v-divider>
                      </v-sheet>
                    </v-list>
                  </v-col> 
                </v-row>
            </v-card>
          </v-menu>
          <v-btn text="" to="/contact">Contact</v-btn>
          <v-menu   
            bottom="" 
            offset-y
            :nudge-width="250">
            <template v-slot:activator="{ on }"> 
              <v-btn  v-on="on" icon="">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-card color="primary lighten-1" class=""> 
                <v-row class="mx-3"> 
                  <v-col >
                    <v-subheader class="white--text font-weight-bold">Oteher pages</v-subheader>
                    <v-divider></v-divider>
                    <v-divider></v-divider>
                    <v-list single-line dense="" subheader=""> 
                      <!-- <v-sheet >
                        <v-list-item to="/biblestudies" @click="clicked">Bible Studies</v-list-item> 
                        <v-divider></v-divider>
                      </v-sheet>
                      <v-sheet >
                        <v-list-item to="/ministries" @click="clicked">Ministries</v-list-item> 
                        <v-divider></v-divider>
                      </v-sheet> -->
                      <v-sheet v-if="!us" >
                        <v-list-item to="/login" @click="clicked">Login</v-list-item> 
                        <v-divider></v-divider>
                      </v-sheet>
                      
                      <v-sheet v-if="us" >
                        <v-list-item to="/cpanel" @click="clicked">cpanel</v-list-item> 
                        <v-divider></v-divider>
                      </v-sheet>

                        <v-sheet v-if="us" >
                        <v-list-item @click="not.logout()">Logout</v-list-item> 
                        <v-divider></v-divider>
                      </v-sheet>
                    </v-list>
                  </v-col> 
                </v-row>
            </v-card>
          </v-menu>
        </v-toolbar-items> 
      </v-app-bar>

      <!-- //MOBILE TOOLAR -->
      <v-app-bar v-else
        app="" dark=""
        :color="tb.tbColor"
        :flat="tb.tbFlat">
        <router-link to="/">
          <v-img   
            class="mx-4" 
            height="50"  
            max-width="50"
            :src="require(`@/assets/teresiansisters/logo.png`)"
          /> 
        </router-link>
        <router-link to="/" class="not-line0" >
          <v-toolbar-title class="white--text font-weight-bold" >{{not.appName}}</v-toolbar-title>
        </router-link>
        <v-spacer></v-spacer>
        <v-app-bar-nav-icon @click="navOpen()"/> 
      </v-app-bar>
      <div class="not-fixed not-op6 mt-10 pt-5" >
        <hr> 
      </div>
    </div>

    <!-- //HR LINE -->
    
  </div>
</template>

<script>
export default {
  props:["not"],
  data: () => ({
     
  }),
  computed: {
    phoneSize(){ 
      let  width = this.not.vs.width 
      if(width<1000){
        return true
      }else{
        return false
      }
    },
    us(){
      return this.not.us
    },
    //////
    tb(){ 
      return this.$store.getters.getToolbar
    },
  },
  methods: {
    navOpen(){
      this.$emit("navOpen")
    },
    clicked(){}
  },
};
</script>
